/* eslint-disable react/prop-types */
import React, {  useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import TextField from '../TextField'
import Form from 'component/utils/Form'
import Modal from 'component/utils/Modal'
import {useDropzone} from 'react-dropzone'
import WarningModal from 'component/scheduleBlock/WarningModal'
import ClearSVG from 'component/svgComponents/clear'
import PictogramModalErrorNew from 'component/pictograms/PictogramErrorModalNew'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { useDebounce } from './debounce'

const PictogramAddModal = ({
  closeModal,
  user,
  submit,
  token,
  translate,
  attributeAlreadyExists,
  handleAttributeAlreadyExists
}) => {


  useEffect(() =>  {

    if(pictograms.length >= 4  !== hasScroll) setHasScroll(pictograms.length >=4)
    
  }, )


  

  const [hasScroll, setHasScroll] = useState(false)
  const [pictograms,setPictograms] = useState([])
  const [repeteadNames, setRepeatedNames] = useState([])
  const [openUploadErrorModal, setOpenUploadErrorModal] = useState(false)
  const [openWarningUploadModal, setopenWarningUploadModal] = useState(false)
  const [attributeName,setAttributeName] = useState("")
  const [validName,setvalidName] = useState(true)
  const [attributeNameAlreadyExists, setAttributeNameAlreadyExists] = useState(false)
  
  useEffect(() => {
    if(!validName) setvalidName(true)
  },  [attributeName])
  

  const onChange = () => {
  
    new Api(token)
   .get(API_URL.CHECK_ATTRIBUTE_NAME, {name: attributeName})
   .then((response) => {
     
     setAttributeNameAlreadyExists(response.data)
   })
   .catch((error) => {
     console.log("error", error)
   })
    
   };

   const debouncedOnChange = useDebounce(onChange);

  const [warningModal,setWarningModal] = useState(false)

  // eslint-disable-next-line react/prop-types
  const PictogramDropzone = ({index, onDrop, onFileDialogCancel, img, pictograms, changeMode}) => {

    const { getRootProps, getInputProps } = useDropzone({
      onDrop: (acceptedFiles) => onDrop(acceptedFiles, index),
      onFileDialogCancel: () => onFileDialogCancel(index),
      accept: {
        'image/jpeg': [],
        'image/png': []
      },
      multiple: true
      
    })

    return (
      changeMode ? 
      <div> 
         <button style={{marginBottom: '5px'}} {...getRootProps()} id='pictogram-change-delete'>Alterar</button> 
         <input {...getInputProps()} /> 

      </div>
      : 
      <div  className='pictogram-box' style={{marginTop: pictograms && pictograms.length > 0 ? '28px': '0px',}} {...getRootProps()}>
        <input {...getInputProps()} />
        {renderImageOrSVG(img)}
      </div>
    )

  }

  const handleDrop = (files, index) => {
    const file = files[0]
  
    if(!file) {
      setOpenUploadErrorModal(true)
      return
    }

    const newPictograms = [...pictograms]
    if(index === -1 ) index = 0
    
    if(typeof pictograms[index] === 'undefined' ) {
      files.forEach(currentFile => {
        const pictogram = {img: URL.createObjectURL(currentFile), file:currentFile}
        newPictograms.push(pictogram)
      })
     
    }

    else {
      if(files.length > 1) {
        setopenWarningUploadModal(true)
        return
      }
      newPictograms[index].img = URL.createObjectURL(file)
      newPictograms[index].file = file
    }
    setPictograms(newPictograms)
  
  }

  PictogramDropzone.propTypes = {
    index: PropTypes.number.isRequired,
    img: PropTypes.string,
    pictograms: PropTypes.array
  }

  const handleDeletePictogram = (index) => {
    const updatedPictograms = [...pictograms]
    if(!pictograms[index].img) {
      updatedPictograms.splice(index,1)
    }
    else {
      updatedPictograms[index].img = null
    }
    setPictograms(updatedPictograms)
  }

  const handleDialogCancel = (index) => {
    
    if(typeof pictograms[index] !== 'undefined' && index !== -1 && index !== pictograms.length ) return
    const newPictograms = [...pictograms]
    newPictograms.push({})
    setPictograms(newPictograms)
  }
  const renderImageOrSVG = (img) => {

    if(img) {
      return <div>
        <img style={{width: '111px', height: '112px', padding: '5px', display: 'flex'}} src={img} />
       
      </div>
    }

    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.2 8.8V0H8.8V8.8H0V11.1H8.8V20H11.1L11.2 11.1H20V8.8H11.2Z" fill="#41A017"/>
           </svg>
  }

  const renderUploadErrorModal = () => {
    if(!openUploadErrorModal) return
    return (
      <PictogramModalErrorNew
        above
        onConfirm={() => setOpenUploadErrorModal(false)}
        text={"Houve um erro ao adicionar a imagem no pictograma"}
        title={'Ops!'}
        details={"Formato não suportado"}
        okButton={'Tentar novamente'}
      />
    )
  }


  const renderWarningUploadModal = () => {
    if(!openWarningUploadModal) return
    return (
      <PictogramModalErrorNew
        above
        onConfirm={() => setopenWarningUploadModal(false)}
        text={"Houve um erro ao adicionar as imagens no pictograma"}
        title={'Ops!'}
        details={"arraste as imagens para o bloco de adição "}
        okButton={'Tentar novamente'}
      />
    )
  }

  // eslint-disable-next-line react/prop-types
  const renderPictogramsImages = () =>   pictograms.map((pictogram,index) => 
  
    <div  key={index}>
      <div className='pictogram-input-div'>
       
        <input style={{paddingRight: '30px', border: repeteadNames.filter(n => n !== "").includes((pictogram.name || "").toLowerCase().trimEnd()) && '1px solid #b42a27', color: "#3C3738", fontSize: '10px'}}   placeholder='Digite um nome' className='pictograms-box-input' type='text' value={pictogram.name} onChange={(e) => {
        
          
          const updatedPictograms = [...pictograms]
          updatedPictograms[index].name = e.target.value.trimStart()
          setPictograms(updatedPictograms)

          
          const names = updatedPictograms.map((input) => (input.name || "").toLowerCase().trimEnd());
          const duplicateNames = names.filter(
            (name, i) => names.indexOf(name) !== i
          );

          setRepeatedNames(duplicateNames);
            
        } } />

        <ClearSVG className={`${pictogram.name ? "pictogram-input-clear" : "hide-shadow"}`} onClick={() => {
          const updatedPictograms = [...pictograms]
          updatedPictograms[index].name = ""
          setPictograms(updatedPictograms)
        }} />
      </div>
      
      <PictogramDropzone 
        index={index} 
        onDrop={handleDrop} 
        onFileDialogCancel={handleDialogCancel} 
        img={pictogram.img} 
        key={pictogram.name} 
        className='pictogram-box'/>

      <div className='pictogram-actions'>

        <PictogramDropzone 
          index={index} 
          changeMode
          onDrop={handleDrop} 
          onFileDialogCancel={handleDialogCancel} 
          img={pictogram.img} 
          key={pictogram.name} 
          className='pictogram-box'/>

        <button id='pictogram-img-delete' onClick={() => {
          handleDeletePictogram(index)
        }}>Excluir</button>
      </div>
    </div>  
       )
  // eslint-disable-next-line react/prop-types
  const renderPictograms = () => <PictogramDropzone pictograms={pictograms} index={pictograms.length} onDrop={handleDrop} onFileDialogCancel={handleDialogCancel}  />

  const isButtonDisabled = !attributeName.trim() || pictograms.length === 0 || pictograms.some(p => !p.name) || repeteadNames.length > 0

  const convertFileToBase64 = (file) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  const handleSubmit = async () => {
    const pictogramsWithBase64 = await Promise.all(
      pictograms.map(async (pictogram) => {
        const base64 = pictogram.file ? await convertFileToBase64(pictogram.file) : null;
        return {
          name: pictogram.name,
          img: base64
        };
      })
    );

    const jsonData = {
      name: attributeName.trim(),
      qtyPictogram: pictograms.length,
      cdLdap: user.username,
      dsLdap: user.fullName,
      isCharge: 0,
      pictogramParams: pictogramsWithBase64
    };

    submit(jsonData);
  };


  const handleCloseModal = () => {
    if(attributeName.length || pictograms.length > 0 ) {
      setWarningModal(true)
    }
    else {
      closeModal()
    }
  }
  const renderWarningModalWeekly = () => {

    if(!warningModal) return
    const handleConfirm = () => {
      setAttributeName("")
      setPictograms([])
      setWarningModal(false)
      closeModal()
    }

    const handleCancel = () => {
      setWarningModal(false)
    }

    return (
      <WarningModal
        customClass='pictogram-warning-modal'
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        customText='Gostaria de sair sem salvar a tela de cadastro mesmo assim?'
        translate={translate}
        
      />
    )

  }

  return (
    <>
    
      {renderUploadErrorModal()}
      {renderWarningModalWeekly()}
      {renderWarningUploadModal()}
    
      <Modal
        modalWidth={'624px'}
        onCloseModal={handleCloseModal}
        size='md'
        under
        className={`pictograms-add-modal ${warningModal ? 'hide-shadow' : ''}`}
      >
        <h3 style={{fontSize: '24px', marginBottom:'32px', marginTop: '-1px', paddingTop: '4px'}}>
          <strong style={{color: 'black'}}>Novo cadastro de atributo</strong>
        </h3>

        <p style={{marginBottom:'-10px', color: '#222020', fontWeight: '600', fontSize: '13px'}}>Atributo</p>

          <TextField
                    type='text'
                    required
                    clearIcon
                    onRightIconClick={() => setAttributeName("")}
                    onChange={(e) => {
                      debouncedOnChange()
                      setAttributeName(e.target.value)
                      if(attributeAlreadyExists || attributeNameAlreadyExists) {
                        handleAttributeAlreadyExists(false)
                        setAttributeNameAlreadyExists(false)
                      }
                    }}
                    value={attributeName}
                    placeholder="Digite um nome de atributo"
                    fill
                    errorMsg="Já existe um atributo com esse nome"
                    error={attributeAlreadyExists || attributeNameAlreadyExists}
                    
                  
                  />
  
        <p style={{marginBottom:'16px', color: '#222020', fontWeight: '600', fontSize: '13px'}}>Pictogramas</p>
        <section className={`pictograms-area ${hasScroll ? 'pictogram-border' : ''}`} >
          
          {renderPictogramsImages()}
          {renderPictograms()}
          
        </section>
        <div className='mission-block-new-modal-actions'>

          <button
            
            disabled={isButtonDisabled}
            onClick={handleSubmit}
            className='mission-save'
          >
            {translate('save_button_label')}
          </button>

          <button
            onClick={handleCloseModal}
            className='mission-cancel'
          >
          {translate('close_button_label')}
          </button>


        </div>
      </Modal>
    </>
    
 )
}

PictogramAddModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  handleAttributeAlreadyExists: PropTypes.func,
  user:PropTypes.object,
  attributeAlreadyExists: PropTypes.func

}


export default Form()(PictogramAddModal)

export { PictogramAddModal }
